import { Button, Form, InputFieldRhf, XStack, Error } from '@my/ui'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { zodEmailValidator } from 'app/utils/zod-email-validator'

const formSchema = z.object({
  email: z.string().refine(zodEmailValidator, { message: 'Invalid email' }),
})

export type UniversityEmailFormValues = z.infer<typeof formSchema>

export interface UniversityEmailFormProps {
  loading: boolean
  error?: string
  onSubmit: (values: UniversityEmailFormValues) => void
}

export const UniversityEmailForm = (props: UniversityEmailFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
  })

  return (
    <Form
      gap="$3"
      w="100%"
      onSubmit={handleSubmit((data) => {
        props.onSubmit(data)
      })}
    >
      <InputFieldRhf
        name="email"
        control={control}
        label="University email"
        placeholder="Student Email Address"
        inputMode="email"
        hideLabel
        required
      />

      {props.error && <Error error={props.error} />}
      {errors.email?.message && <Error error={errors.email.message} />}

      <XStack gap="$3">
        <Form.Trigger asChild fd="row" ai="center">
          <Button
            plain
            backgroundColor="$primary"
            hoverStyle={{ backgroundColor: '$primary4' }}
            w="100%"
            loading={props.loading}
          >
            Verify
          </Button>
        </Form.Trigger>
      </XStack>
    </Form>
  )
}
